export class SubscriptionSpecs {
    keys = []; // IntegrationKey

    constructor() {
        this.keys = [];
    }
}
